<template>

  <div class="blog-area ptb-100">
    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-md-12">
          <aside class="widget-area left-sidebar">
            <div class="widget widget_search">
              <form class="search-form" @submit.prevent>
                <label>
                  <input type="search" class="search-field" placeholder="Search..." v-model="searchQuery"
                    @input="onSearchInput" @focus="showDropdown = true" @blur="hideDropdown" autocomplete="off">
                </label>
                <button type="submit"><i class="ri-search-2-line"></i></button>

                <ul v-if="showDropdown && searchResults.length" class="search-dropdown">
                  <li v-for="blog in searchResults" :key="blog.slug" @mousedown.prevent="goToBlog(blog.slug)"
                    class="dropdown-item">
                    {{ blog.title }}
                  </li>
                </ul>
              </form>
            </div>
            <!-- <div class="widget widget_meander_software_posts_thumb">
                            <h3 class="widget-title">Popular Posts</h3>
                            <article class="item" v-for="(blog) in popularBlogs" :key="blog.id">
                                <router-link :to="`/resource-detail/${blog?.slug}`"  class="thumb"><span class="fullimage cover"
                                        :style="{ backgroundImage: 'url(' + $backendUrl + blog.image?.url + ')' }"
                                        role="img"></span></router-link>
                                <div class="info">
                                    <h4 class="title usmall"><router-link :to="`/resource-detail/${blog?.slug}`" >{{ blog.title
                                    }}</router-link></h4>
                                    <span class="date"><i class="ri-calendar-2-fill"></i>{{
                                        formatDate(blog.publishedAt) }}</span>
                                </div>
                            </article>

                        </div> -->
            <div class="widget widget_categories d-none d-lg-block" v-if="categories?.length">
           <span class="d-flex justify-content-between">
            <h3 class="widget-title">Categories</h3> <span v-if="activeCategory?.length" >
              
              <router-link style="color: #ed2775; text-decoration: underline;"  :to="{ path: '/resources'}">
                Clear
                    
                  </router-link>
              </span>
           </span>
              <ul>
                <li v-for="(category) in categories" :key="category?.slug">
                  <router-link :class="category?.slug === activeCategory ? 'activepath cursor-pointer ' : 'cursor-pointer '" :to="{ path: '/resources', query: { category: category?.slug } }">
                     {{ category.name }}  
                      <!-- <span class="post-count">(2)</span> -->
                    
                  </router-link>
                </li>
              </ul>
            </div>
            <!-- <div class="widget widget_categories" v-if="services?.length">
                            <h3 class="widget-title">Services</h3>
                            <ul>
                                <li v-for="(service) in services" :key="service?.slug">
                                    <router-link :to="{path:'/resources',query:{service:service?.slug}}"  >
                                    <a class="cursor-pointer ">{{ service.name }}
                                       
                                    </a>
                                </router-link>
                                </li>
                            </ul>
                        </div>
                        <div class="widget widget_categories" v-if="industries?.length">
                            <h3 class="widget-title">Industries</h3>
                            <ul>
                                <li v-for="(industrie) in industries" :key="industrie?.slug">
                                    <router-link :to="{path:'/resources',query:{industrie:industrie?.slug}}" >
                                    <a class="cursor-pointer ">{{ industrie.name }}
                                       
                                    </a>
                                </router-link>
                                </li>
                            </ul>
                        </div>
                        <div class="widget widget_categories" v-if="technologies?.length">
                            <h3 class="widget-title">Technologies</h3>
                            <ul>
                                <li v-for="(Technologie) in technologies" :key="Technologie?.slug">
                                    <router-link :to="{path:'/resources',query:{technologie:Technologie?.slug}}" >
                                    <a class="cursor-pointer ">{{ Technologie.name }}
                                        
                                    </a>
                                </router-link>
                                </li>
                            </ul>
                        </div> -->

          </aside>
        </div>
        <div class="col-lg-8 col-md-12">
          <div class="row justify-content-center">
            <BlogSkleton v-if="isLoading" />
            <div v-else class="col-lg-6 col-md-6" v-for="(blog) in blogs" :key="blog?.slug">
              <div class="single-blog-post">
                <div class="image">
                  <router-link :to="`/resource-detail/${blog?.slug}`" class="d-block">
                    <img style="height:250px;  " :src="$backendUrl + blog.image?.url" :alt="blog.image?.alternativeText || blog.title + ' - Blog Image' || 'Blog Image'">
                    <!-- <img  :src="blog.blog_img.url" alt="blog"> -->
                  </router-link>
                  <!-- <router-link :to="`/resource-detail/${blog.attributes.slug}`"  class="tag">{{
                                        blog.attributes.blog_categories.data[0].attributes.name
                                    }}</router-link> -->
                </div>
                <div class="content">
                  <ul class="meta">
                    <li><i class="ri-time-line"></i> {{ formatDate(blog.publishedAt) }}</li>
                    <!-- <li><i class="ri-stack-fill"></i> {{ blog?.ms_blog_categories[0]?.name }}</li> -->
                    <!-- <li><i class="ri-message-2-line"></i> <router-link to="/resource-detail">(0) Comment</router-link></li> -->
                  </ul>
                  <h3><router-link :to="`/resource-detail/${blog?.slug}`">{{ blog.title }}</router-link></h3>
                </div>
              </div>
            </div>






            <div class="col-lg-12 col-md-12" v-if="blogs?.length > 9">
              <div class="pagination-area">
                <div class="nav-links">
                  <span v-for="page in totalPages" :key="page"
                    :class="['page-numbers', { current: page === currentPage }]" @click="onPageChange(page)"
                    style="cursor:pointer">
                    {{ page }}
                  </span>
                  <span v-if="currentPage < totalPages" class="next page-numbers" title="Next Page"
                    @click="onPageChange(currentPage + 1)" style="cursor:pointer">
                    <i class="ri-arrow-right-line"></i>
                  </span>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.activeclass:active {
  color: brown;
}

.blog-area {
    padding-bottom: 50px;
}
.comig-soon-outer {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
}
.search-dropdown {
  position: absolute;
  background: #fff;
  border: 1px solid #eee;
  width: 100%;
  z-index: 10;
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: 300px;
  overflow-y: auto;
}

.dropdown-item {
  padding: 8px 12px !important;
  cursor: pointer;
  border-bottom: 1px solid #bababa6e !important;
  white-space: unset !important;
}

.dropdown-item:hover {
  background: #f5f5f5;
}
.activepath{
  color:#ed2775 !important;
}

/* @media screen and (max-width: 600px) {
  .blog-area {
    padding-top: 85px !important;
}
} */
</style>
<script>
import { watchEffect } from "vue";
import { useGetBlogs, useGetBlogByCategorySlug, GET_BLOG_BY_Category_SLUG, GET_BLOG_BY_service_SLUG, Use_Search_BLOG_BY_SLUG, Search_BLOG_BY_SLUG, GET_BLOGS } from "../../services/graphqlService";

import axios from "axios";
import BlogSkleton from './BlogSkleton.vue'
import { provideApolloClient } from "@vue/apollo-composable";
import apolloClient from "../../apollo";
import { injectSchemaMarkup, generateResourceListingSchema } from "../../utils/schemaUtils";
export default {
  name: 'Blog',
  components: {
    BlogSkleton
  },
  data() {
    return {
      isLoading: true,
      blogs: [],
      categories: [],
      services: [],
      industries: [],
      technologies: [],
      popularBlogs: [],
      currentPage: 1,
      itemsPerPage: 10, // changed to 15 for consistency
      totalItems: 0,
      totalPages: 0,
      searchQuery: "",
      searchResults: [],
      showDropdown: false,
activeCategory:''
    };
  },

  watch: {
    // eslint-disable-next-line no-unused-vars
    '$route.query.category'(newSlug, oldSlug) {
      
      this.activeCategory=newSlug
      if(newSlug?.length){

        this.GetBlogsbyCategory(newSlug, 'category')
      }
      else{
        this.GetBlogs()
      }
    },
    // '$route.query.service'(newSlug, oldSlug) {
    //   this.GetBlogsbyCategory(newSlug, 'service')
    // },
    // '$route.query.industrie'(newSlug, oldSlug) {
    //   this.GetBlogsbyCategory(newSlug, 'industrie')
    // },
    // '$route.query.technologie'(newSlug, oldSlug) {
    //   this.GetBlogsbyCategory(newSlug, 'technologie')
    // },
  },

  methods: {

    async GetBlogs() {
      let variables = {
        sort: [
          "createdAt:desc"
        ],
        pagination: { page: this.currentPage, pageSize: this.itemsPerPage }
      }
      const { data } = await apolloClient.query({
        query: GET_BLOGS,
        variables
      })
      watchEffect(() => {
        if (data?.meanderSoftwareBlogs?.length) {
          this.blogs = data.meanderSoftwareBlogs.slice()
          if (data?.meanderSoftwareBlogs_connection?.pageInfo) {
            this.totalItems = data.meanderSoftwareBlogs_connection.pageInfo.total;
            this.totalPages = data.meanderSoftwareBlogs_connection.pageInfo.pageCount;
          }
        } else {
          this.blogs = [];
        }
        this.isLoading = false;
      });


    },

    async GetBlogsbyCategory(slug, mode) {
      let variables;
      if (mode === 'category') {
        variables = {
          filters: {
            ms_blog_categories: {
              slug: { eq: slug }
            }
          },
          pagination: { page: this.currentPage, pageSize: this.itemsPerPage }
        }
      }
      else if (mode === 'service') {

        variables = {
          filters: {
            ms_blog_services: {
              slug: { eq: slug }
            }
          },
          pagination: { page: this.currentPage, pageSize: this.itemsPerPage }
        }
      }
      else if (mode === 'industrie') {

        variables = {
          filters: {
            ms_blog_industries: {
              slug: { eq: slug }
            }
          },
          pagination: { page: this.currentPage, pageSize: this.itemsPerPage }
        }
      }
      else if (mode === 'technologie') {

        variables = {
          filters: {
            ms_blog_technologies: {
              slug: { eq: slug }
            }
          },
          pagination: { page: this.currentPage, pageSize: this.itemsPerPage }
        }
      }
 
      
      const { data } = await apolloClient.query({
        query: GET_BLOG_BY_Category_SLUG,
        variables
      })
      watchEffect(() => {
        if (data?.meanderSoftwareBlogs?.length) {
          this.blogs = data.meanderSoftwareBlogs;
          if (data?.meanderSoftwareBlogs_connection?.pageInfo) {
            this.totalItems = data.meanderSoftwareBlogs_connection.pageInfo.total;
            this.totalPages = data.meanderSoftwareBlogs_connection.pageInfo.pageCount;
          }
        } else {
          this.GetBlogs()
          // this.blogs = [];
          // this.totalItems = data?.meanderSoftwareBlogs?.length;
          // this.totalPages = 0
        }
        this.isLoading = false;
      });
    },
    async onSearchInput() {
      if (this.searchQuery.trim() === "") {
        this.searchResults = [];
        this.showDropdown = false;
        return;
      }
      const query = this.searchQuery.toLowerCase();

      const variables = {
        "filters": {
          "title": {
            "containsi": query
          }
        },
      }
      const { data } = await apolloClient.query({
        query: Search_BLOG_BY_SLUG,
        variables
      })
      watchEffect(() => {
        if (data?.meanderSoftwareBlogs?.length) {
          this.searchResults = data.meanderSoftwareBlogs;
        } else {
          this.searchResults = [];
        }
        this.isLoading = false;
      });
      this.showDropdown = true;
    },
    hideDropdown() {
      setTimeout(() => {
        this.showDropdown = false;
      }, 200);
    },
    goToBlog(slug) {
      this.$router.push(`/resource-detail/${slug}`);
      this.showDropdown = false;
      this.searchQuery = "";
    },
    async getCategories() {
      const response = await axios.get(`${this.$backendUrl}/api/ms-blog-categories`);
      this.categories = response.data.data;
    },
    async getService() {
      const response = await axios.get(`${this.$backendUrl}/api/ms-blog-services`);
      this.services = response.data.data;
    },
    async getindustries() {
      const response = await axios.get(`${this.$backendUrl}/api/ms-blog-industries`);
      this.industries = response.data.data;
    },
    async gettechnologies() {
      const response = await axios.get(`${this.$backendUrl}/api/ms-blog-technologies`);
      this.technologies = response.data.data;
    },

    async fetchPopularPosts() {
      const response = await axios.get(`${this.$backendUrl}/api/meander-software-blogs?pagination[limit]=5&populate=image`);
      this.popularBlogs = response.data.data;
    },

    formatDate(date) {
      if (!date) return "N/A"; // Return default text if date is missing
      const options = { year: "numeric", month: "short", day: "2-digit" };
      return new Date(date).toLocaleDateString(undefined, options);
    },

    onPageChange(page) {
      if (page > 0 && page <= this.totalPages) {
        this.currentPage = page;
        this.GetBlogs();
      }
    },
    
    setResourcesPageSEO() {
      // Set the page title
      document.title = 'Resources - Meander Software';
      
      // Helper to set or update a meta tag
      function setMeta(name, content, attr = 'name') {
        let element = document.querySelector(`meta[${attr}="${name}"]`);
        if (!element) {
          element = document.createElement('meta');
          element.setAttribute(attr, name);
          document.head.appendChild(element);
        }
        element.setAttribute('content', content || '');
      }

      // Set basic meta tags
      setMeta('title', 'Resources - Meander Software');
      setMeta('description', 'Explore our comprehensive collection of resources, articles, and insights on software development, technology trends, and industry best practices.');
      setMeta('keywords', 'software development, technology resources, programming articles, tech insights, development guides');

      // Open Graph tags
      setMeta('og:title', 'Resources - Meander Software', 'property');
      setMeta('og:description', 'Explore our comprehensive collection of resources, articles, and insights on software development, technology trends, and industry best practices.', 'property');
      setMeta('og:type', 'website', 'property');
      setMeta('og:url', window.location.href, 'property');
      setMeta('og:image', 'https://meander.software/og-default-image.jpg', 'property');
      setMeta('og:image:width', '1200', 'property');
      setMeta('og:image:height', '630', 'property');
      setMeta('og:image:alt', 'Resources - Meander Software', 'property');

      // Twitter Card tags
      setMeta('twitter:title', 'Resources - Meander Software', 'name');
      setMeta('twitter:description', 'Explore our comprehensive collection of resources, articles, and insights on software development, technology trends, and industry best practices.', 'name');
      setMeta('twitter:image', 'https://meander.software/og-default-image.jpg', 'name');
      setMeta('twitter:image:alt', 'Resources - Meander Software', 'name');
      setMeta('twitter:card', 'summary_large_image', 'name');
      setMeta('twitter:site', '@meandersoftware', 'name');
      setMeta('twitter:creator', '@meandersoftware', 'name');

      // Update canonical URL
      let canonical = document.querySelector('link[rel="canonical"]');
      if (canonical) {
        canonical.setAttribute('href', window.location.href);
      } else {
        canonical = document.createElement('link');
        canonical.setAttribute('rel', 'canonical');
        canonical.setAttribute('href', window.location.href);
        document.head.appendChild(canonical);
      }
    }
  },
  mounted: async function () {
    // Check if there are any query parameters in the route
    const queryParams = this.$route.query;
    this.activeCategory = queryParams.category
    const hasQueryParams = queryParams.category || queryParams.service || queryParams.industrie || queryParams.technologie;
    
    if (hasQueryParams) {
      // If there are query parameters, the watchers will handle the API calls
      // We just need to trigger the appropriate method based on the current query
      if (queryParams.category) {
        this.GetBlogsbyCategory(queryParams.category, 'category');
      }
      //  else if (queryParams.service) {
      //   this.GetBlogsbyCategory(queryParams.service, 'service');
      // } else if (queryParams.industrie) {
      //   this.GetBlogsbyCategory(queryParams.industrie, 'industrie');
      // } else if (queryParams.technologie) {
      //   this.GetBlogsbyCategory(queryParams.technologie, 'technologie');
      // }
    } else {
      // If no query parameters, get all blogs
      this.GetBlogs();
    }
    
    await this.getCategories();
    // await this.getindustries();
    // await this.gettechnologies();
    // await this.getService();
    // await this.fetchPopularPosts();
    
    // Set SEO meta tags for the resources listing page
    this.setResourcesPageSEO();
  }

};
</script>